import FolderRoundedIcon from "@mui/icons-material/FolderRounded";
import InsertDriveFileOutlinedIcon from "@mui/icons-material/InsertDriveFileOutlined";
import LinkIcon from "@mui/icons-material/Link";
import PhotoOutlinedIcon from "@mui/icons-material/PhotoOutlined";
import VideoCameraBackOutlinedIcon from "@mui/icons-material/VideoCameraBackOutlined";
import React from "react";

import { FileSystemNodeType } from "@/shared/domain/files/filesystem/fileSystemNode";
import { isImage, isVideo } from "@/shared/domain/files/fileTypes";

interface RowTypeIconProps {
  rowName: string;
  rowType: FileSystemNodeType;
  /** Whether the row is a link to another file, which takes the link icon whatever its name. */
  isLink?: boolean;
}

export const RowTypeIcon: React.FC<RowTypeIconProps> = ({
  rowName,
  rowType,
  isLink = false,
}) => {
  if (rowType === FileSystemNodeType.Directory) {
    return <FolderRoundedIcon color="info" />;
  }

  if (isLink) {
    return <LinkIcon color="info" titleAccess="Link" />;
  }

  if (isImage(rowName)) {
    return <PhotoOutlinedIcon color="info" />;
  } else if (isVideo(rowName)) {
    return <VideoCameraBackOutlinedIcon color="info" />;
  }

  return <InsertDriveFileOutlinedIcon color="info" />;
};
